export enum PageSource {
  THANK_YOU_PAGE = 'thankyoupage',
}
